import styled from 'styled-components';

export const PartyJackpotWelcomePopupButtonsContainerBox = styled.div`
    font-size: 1.3em;
    width: 310px;
    display: flex;
    flex-direction: column;
    align-items: center;

    margin-top: 40px;
    margin-bottom: 40px;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin-top: 30px;
        margin-bottom: 30px;

        @media ${({theme}) => theme.mediaQuery.landscape} {
            margin-top: 15px;
            margin-bottom: 15px;
        }
    }

`;
